module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "left",
    attrs: {
      "id": "landmarkTree"
    }
  }, _vm._l((_vm.treeData), function(item, index) {
    return _c('div', {
      staticClass: "landmarkTree-item",
      class: {
        'active': _vm.defaultCollapse == item.id
      }
    }, [_c('span', {
      staticClass: "landmarkTree-item-name",
      on: {
        "click": function($event) {
          return _vm.toggle(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name)), _c('i', {
      staticClass: "triangle-facing-right"
    })]), _vm._v(" "), _c('ul', _vm._l((item.regions), function(row) {
      return _c('li', {
        class: {
          active: row.regionId == _vm.regionId
        },
        staticStyle: {
          "display": "block"
        },
        on: {
          "click": function($event) {
            return _vm.changeRegionId(row)
          }
        }
      }, [_c('i', {
        staticClass: "san_you"
      }), _c('span', {
        staticStyle: {
          "vertical-align": "middle"
        }
      }, [_vm._v(_vm._s(row.localName))])])
    }), 0)])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a08fb79"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landmark-superior-product/module-left-tree.vue
// module id = 1628
// module chunks = 1